(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();
  const originalImages = new WeakMap();
  const imageAttributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-widths', 'data-sizes', 'data-aspectratio', 'data-photoswipe-src', 'data-photoswipe-width', 'data-photoswipe-height', 'width', 'height', 'alt', 'class'];
  let activeViewer = null;

  function button(label, text, className) {
    const el = document.createElement('button');
    el.type = 'button';
    el.className = className;
    el.setAttribute('aria-label', label);
    el.textContent = text;
    return el;
  }

  function labelFor(config, variantId) {
    return config.verifiedVariants[String(variantId)] || null;
  }

  function fitLevel(gallery) {
    return gallery.currItem.initialZoomLevel || gallery.currItem.fitRatio;
  }

  function openFacts(state, trigger) {
    const label = labelFor(state.config, state.variantId);
    if (!label) return false;
    const alt = `${state.config.strings.facts}: ${state.config.productTitle}, ${label.title}`;
    const pages = label.pages || [{src: label.src, width: label.width, height: label.height}];
    const items = pages.map((page, index) => ({src: page.src, msrc: page.src, w: page.width, h: page.height, title: alt, alt, okIsFacts: true, okLabelTitle: label.title + (pages.length > 1 ? ` · Part ${index + 1} of ${pages.length}` : '')}));
    return openImageViewer(state, trigger, items, 0, true);
  }

  function openImageViewer(state, trigger, items, startIndex, factsOnly = false) {
    if (!items.length || startIndex < 0 || startIndex >= items.length || !window.PhotoSwipe || activeViewer || document.querySelector('.pswp.pswp--open')) return false;
    const firstItem = items[startIndex];
    // The native Expanse template omits default-UI elements such as the preloader.
    // Use the existing PhotoSwipe core with our own root/UI; never mutate its native root.
    const root = document.createElement('div');
    root.className = 'pswp';
    root.tabIndex = -1;
    root.setAttribute('aria-hidden', 'true');
    const background = document.createElement('div'); background.className = 'pswp__bg';
    const scrollWrap = document.createElement('div'); scrollWrap.className = 'pswp__scroll-wrap';
    const track = document.createElement('div'); track.className = 'pswp__container';
    for (let i = 0; i < 3; i++) {const item = document.createElement('div'); item.className = 'pswp__item'; track.append(item);}
    scrollWrap.append(track); root.append(background, scrollWrap);
    const strings = state.config.strings;
    const scrollPosition = {x: window.scrollX, y: window.scrollY};
    const disabledBackground = Array.from(document.body.children).filter(el => !el.contains(root) && !['SCRIPT', 'STYLE', 'LINK'].includes(el.tagName)).map(el => [el, el.inert]);
    const panel = document.createElement('div');
    panel.className = 'ok-facts-viewer__panel';
    const heading = document.createElement('div');
    heading.className = 'ok-facts-viewer__heading';
    const title = document.createElement('h2');
    title.textContent = firstItem.okIsFacts ? strings.facts : (strings.imageTitle || strings.enlarge);
    const identity = document.createElement('p');
    identity.setAttribute('aria-live', 'polite');
    identity.textContent = firstItem.okIsFacts && firstItem.okLabelTitle ? `${state.config.productTitle}, ${firstItem.okLabelTitle}` : (firstItem.alt || state.config.productTitle);
    const close = button(strings.close, '×', 'ok-facts-viewer__close');
    const titleGroup = document.createElement('div');
    titleGroup.append(title, identity);
    heading.append(titleGroup, close);
    const controls = document.createElement('div');
    controls.className = 'ok-facts-viewer__controls';
    const minus = button(strings.zoomOut, '−', 'ok-facts-viewer__control');
    const plus = button(strings.zoomIn, '+', 'ok-facts-viewer__control');
    const fit = button(strings.fit, strings.fit, 'ok-facts-viewer__control ok-facts-viewer__fit');
    const zoomValue = document.createElement('output');
    zoomValue.setAttribute('aria-live', 'polite');
    controls.append(minus, zoomValue, plus, fit);
    const help = document.createElement('p');
    help.className = 'ok-facts-viewer__help';
    help.textContent = firstItem.okIsFacts ? strings.help : (strings.imageHelp || strings.enlarge);
    panel.append(heading, controls, help);
    const originalLink = document.createElement('a');
    originalLink.href = firstItem.src;
    originalLink.target = '_blank';
    originalLink.rel = 'noopener';
    originalLink.textContent = strings.original;
    let originalArea = originalLink;
    let previousImage = null;
    let nextImage = null;
    if (items.length > 1) {
      originalArea = document.createElement('div');
      originalArea.className = 'ok-facts-viewer__original ok-image-viewer__navigation';
      previousImage = button(strings.previous, '‹', 'ok-facts-viewer__control');
      nextImage = button(strings.next, '›', 'ok-facts-viewer__control');
      originalArea.append(previousImage, originalLink, nextImage);
    } else originalLink.className = 'ok-facts-viewer__original';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', firstItem.alt || state.config.productTitle);
    root.append(panel, originalArea);
    const errorMessage = document.createElement('div');
    errorMessage.className = 'pswp__error-msg';
    errorMessage.textContent = factsOnly ? strings.unavailable : (strings.imageUnavailable || strings.original);
    let gallery = null;
    let panelObserver = null;
    let pendingResize = false;
    let settlingGesture = false;
    let settleFrame = null;
    let cleaned = false;
    let restoreFocus = true;
    const finish = () => {
      if (cleaned) return;
      cleaned = true;
      if (window.okPdpViewer && window.okPdpViewer.root === root) window.okPdpViewer = null;
      panelObserver?.disconnect();
      if (settleFrame !== null) cancelAnimationFrame(settleFrame);
      root.remove();
      disabledBackground.forEach(([el, inert]) => el.inert = inert);
      if (activeViewer?.root === root) activeViewer = null;
      if (restoreFocus) {
        window.scrollTo(scrollPosition.x, scrollPosition.y);
        if (trigger.isConnected) trigger.focus({preventScroll: true});
      }
    };
    const closeViewer = (returnFocus = true) => {
      restoreFocus = returnFocus;
      try {gallery?.close();} catch (_) { /* finish below owns all added UI */ }
      finally {
        if (!cleaned) {try {gallery?.destroy();} catch (_) { /* partial init may not support destroy */ }}
        finish();
      }
    };
    try {
    document.body.append(root);
    gallery = new window.PhotoSwipe(root, null, items, {
      mainClass: factsOnly ? 'ok-facts-viewer' : 'ok-facts-viewer ok-image-viewer', index: startIndex, history: false, loop: !factsOnly && items.length > 1, scaleMode: 'fit', allowPanToNext: false,
      pinchToClose: false, closeOnScroll: false, closeOnVerticalDrag: false,
      showAnimationDuration: 0, hideAnimationDuration: 0, maxSpreadZoom: 2,
      getDoubleTapZoom: () => 1, focus: false, escKey: true,
      captionEl: false, closeEl: false, zoomEl: false, shareEl: false,
      fullscreenEl: false, counterEl: false, arrowEl: false, preloaderEl: false,
      tapToClose: false, tapToToggleControls: false,
      timeToIdle: 0, timeToIdleOutside: 0,
      barsSize: {top: 180, bottom: 54},
      errorMsg: errorMessage.outerHTML
    });
    // Do not overwrite PhotoSwipe's pinch-start baselines mid-gesture. Mobile
    // browser chrome can resize while a finger is still on the image.
    const nativeUpdateSize = gallery.updateSize.bind(gallery);
    gallery.updateSize = force => {
      if (settlingGesture || gallery.isDragging() || gallery.isZooming()) {pendingResize = true; return;}
      nativeUpdateSize(force);
    };
    activeViewer = {root, section: state.section, close: closeViewer};
    const currentIndex = () => gallery.getCurrentIndex();
    const updateZoom = () => {
      if (!gallery.currItem) return;
      const relative = gallery.getZoomLevel() / fitLevel(gallery);
      zoomValue.value = `${Math.round(relative * 100)}%`;
      zoomValue.textContent = zoomValue.value;
      minus.disabled = relative <= 1.01;
      plus.disabled = gallery.getZoomLevel() >= 1.99;
    };
    // PhotoSwipe 4 expects PAGE coordinates, not viewport coordinates. Center
    // on the usable image area (below the header), including the page offset.
    const imageCenter = () => {
      const gap = gallery.currItem?.vGap || {top: 180, bottom: 54};
      return {x: gallery.viewportSize.x / 2, y: gap.top + (gallery.viewportSize.y - gap.top - gap.bottom) / 2};
    };
    // PhotoSwipe's rapid pinch-to-one-finger release can request a same-scale
    // settle using stale pinch-start offsets. There is nothing to interpolate:
    // keep the actual dragged position, recompute native bounds, then clamp it.
    const nativeZoomTo = gallery.zoomTo.bind(gallery);
    gallery.zoomTo = (target, point, duration, easing, onUpdate) => {
      const item = gallery.currItem;
      const img = item?.container?.querySelector('.pswp__img:not(.pswp__img--placeholder)') || item?.container?.querySelector('.pswp__img');
      if (!point && img && Math.abs(target - gallery.getZoomLevel()) < 0.000001) {
        const rect = img.getBoundingClientRect();
        const wrap = scrollWrap.getBoundingClientRect();
        const pan = {x: rect.left - wrap.left, y: rect.top - wrap.top};
        nativeZoomTo(target, point, 0, easing);
        gallery.panTo(pan.x, pan.y);
        if (onUpdate) onUpdate(1);
        return;
      }
      nativeZoomTo(target, point, duration, easing, onUpdate);
    };
    let previousCenter = null;
    let resizeView = null;
    const rememberView = () => {
      const item = gallery.currItem;
      const scale = gallery.getZoomLevel();
      const img = item?.container?.querySelector('.pswp__img:not(.pswp__img--placeholder)') || item?.container?.querySelector('.pswp__img');
      if (!previousCenter || !img || !item.w || !item.h || scale <= fitLevel(gallery) + 0.001) {resizeView = null; return;}
      const rect = img.getBoundingClientRect();
      const wrap = scrollWrap.getBoundingClientRect();
      resizeView = {item, scale,
        x: (previousCenter.x - (rect.left - wrap.left)) / (item.w * scale),
        y: (previousCenter.y - (rect.top - wrap.top)) / (item.h * scale)};
    };
    const restoreView = () => {
      const center = imageCenter();
      // Native updateSize resets to fit. Restore the same image point and scale
      // on viewport/chrome/header changes, then let native bounds clamp the pan.
      if (resizeView && resizeView.item === gallery.currItem) {
        const scale = Math.max(fitLevel(gallery), Math.min(2, resizeView.scale));
        const saved = resizeView;
        // Release/inertia has already settled. Restore in this SAME resize
        // task, before paint; even a 1ms animation exposes a fit-size flash.
        gallery.zoomTo(scale, null, 0);
        gallery.panTo(center.x - saved.x * saved.item.w * scale,
          center.y - saved.y * saved.item.h * scale);
      }
      resizeView = null;
      previousCenter = center;
      updateZoom();
    };
    const zoom = factor => {
      const target = factor === 0 ? fitLevel(gallery) : Math.max(fitLevel(gallery), Math.min(2, gallery.getZoomLevel() * factor));
      const center = imageCenter();
      gallery.zoomTo(target, {x: center.x + window.scrollX, y: center.y + window.scrollY}, 0, false, updateZoom);
      updateZoom();
    };
    const updateImage = () => {
      const index = currentIndex();
      const item = items[index];
      if (!item) return;
      title.textContent = item.okIsFacts ? strings.facts : (strings.imageTitle || strings.enlarge);
      const imageIdentity = item.alt || state.config.productTitle;
      const displayIdentity = item.okIsFacts && item.okLabelTitle ? `${state.config.productTitle}, ${item.okLabelTitle}` : imageIdentity;
      identity.textContent = factsOnly ? displayIdentity : `${displayIdentity} · ${index + 1} / ${items.length}`;
      help.textContent = item.okIsFacts ? strings.help : (strings.imageHelp || strings.enlarge);
      originalLink.href = item.src;
      root.setAttribute('aria-label', imageIdentity);
      if (previousImage) previousImage.disabled = items.length < 2;
      if (nextImage) nextImage.disabled = items.length < 2;
      items.forEach(image => image.container?.querySelectorAll('.pswp__img').forEach(img => img.alt = image.alt || state.config.productTitle));
      if (!factsOnly && item.okCell && state.flickity && mobile.matches) {
        const cellIndex = state.flickity.getCellElements().indexOf(item.okCell);
        if (cellIndex >= 0 && state.flickity.selectedElement !== item.okCell) state.flickity.select(cellIndex, false, true);
      }
      updateZoom();
    };
    previousImage?.addEventListener('click', () => {gallery.goTo((currentIndex() - 1 + items.length) % items.length);});
    nextImage?.addEventListener('click', () => {gallery.goTo((currentIndex() + 1) % items.length);});
    close.addEventListener('click', () => closeViewer());
    minus.addEventListener('click', () => zoom(1 / 1.5));
    plus.addEventListener('click', () => zoom(1.5));
    fit.addEventListener('click', () => zoom(0));
    const trapFocus = event => {
      if (event.key === 'Escape') {event.preventDefault(); closeViewer(); return;}
      if (event.key !== 'Tab') return;
      const controls = Array.from(root.querySelectorAll('button:not([disabled]), a[href]')).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      if (!controls.length) return;
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === root)) {event.preventDefault(); last.focus();}
      else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) {event.preventDefault(); first.focus();}
    };
    root.addEventListener('keydown', trapFocus);
    // OK pdp2: fit the photo between the header and the bottom bar, whatever their real heights.
    gallery.listen('parseVerticalMargin', item => {
      const ph = Math.ceil(panel.getBoundingClientRect().height) || 180;
      const bar = root.querySelector('.ok-image-viewer__navigation, .ok-facts-viewer__original');
      const bh = bar ? Math.max(0, Math.ceil(window.innerHeight - bar.getBoundingClientRect().top)) : 54;
      item.vGap.top = ph; item.vGap.bottom = bh || 54;
    });
    gallery.listen('zoomGestureEnded', updateZoom);
    gallery.listen('beforeResize', rememberView);
    gallery.listen('resize', restoreView);
    gallery.listen('pointerUp', () => {
      // Native release starts inertia/bounds animations after this event. Wait
      // for their rendered transform to settle before changing their bounds.
      settlingGesture = true;
      if (settleFrame !== null) cancelAnimationFrame(settleFrame);
      let previousTransform = null;
      let stableFrames = 0;
      const afterSettle = () => {
        if (cleaned) return;
        const transform = gallery.currItem?.container?.style.transform || '';
        const moving = gallery.isDragging() || gallery.isZooming() || gallery.isMainScrollAnimating();
        stableFrames = !moving && transform === previousTransform ? stableFrames + 1 : 0;
        previousTransform = transform;
        if (stableFrames >= 2) {
          settlingGesture = false;
          settleFrame = null;
          if (pendingResize) {pendingResize = false; gallery.updateSize(true);}
          updateZoom();
        } else settleFrame = requestAnimationFrame(afterSettle);
      };
      settleFrame = requestAnimationFrame(afterSettle);
    });
    gallery.listen('afterChange', updateImage);
    gallery.listen('imageLoadComplete', updateImage);
    gallery.listen('destroy', finish);
    gallery.init();
    // OK pdp2: let the viewer's Photos / Supplement Facts tabs jump within this viewer instead of reopening it.
    window.okPdpViewer = {root, factsOnly, srcs: items.map(item => String(item.src || '')), goTo: i => { try { gallery.goTo(i); } catch (_) {} }};
    previousCenter = imageCenter();
    if (window.ResizeObserver) {
      let lastPanelHeight = Math.ceil(panel.getBoundingClientRect().height);
      panelObserver = new ResizeObserver(() => {
        const height = Math.ceil(panel.getBoundingClientRect().height);
        if (height !== lastPanelHeight && !cleaned) {lastPanelHeight = height; gallery.updateSize(true);}
      });
      panelObserver.observe(panel);
    }
    disabledBackground.forEach(([el]) => el.inert = true);
    updateZoom();
    close.focus({preventScroll: true});
    return true;
    } catch (error) {
      restoreFocus = false;
      try {gallery?.destroy();} catch (_) { /* partial initialization is also cleaned */ }
      finish();
      console.warn('Our Kids: Image viewer could not initialize.', error);
      return false;
    }
  }

  function showFacts(state, trigger) {
    const selected = state.section.querySelector('[data-product-select]');
    if (selected) state.variantId = selected.value;
    state.error?.remove(); state.error = null;
    if (openFacts(state, trigger)) return true;
    const label = labelFor(state.config, state.variantId);
    if (!label) return false;
    const message = document.createElement('p');
    message.setAttribute('role', 'status');
    message.className = 'ok-facts-unavailable';
    message.append(document.createTextNode(`${state.config.strings.unavailable} `));
    const original = document.createElement('a'); original.href = label.src;
    original.target = '_blank'; original.rel = 'noopener'; original.textContent = state.config.strings.original;
    message.append(original); state.container.append(message); state.error = message;
    return false;
  }

  function imageItems(state) {
    const cells = state.flickity ? state.flickity.getCellElements() : Array.from(state.section.querySelectorAll('.product-main-slide'));
    const label = labelFor(state.config, state.variantId);
    return cells.flatMap(cell => {
      if (cell.dataset.okMediaType !== 'image') return [];
      const image = cell.querySelector('img[data-photoswipe-src]');
      if (!image) return [];
      const src = image.getAttribute('data-photoswipe-src');
      const width = Number(image.getAttribute('data-photoswipe-width'));
      const height = Number(image.getAttribute('data-photoswipe-height'));
      if (!src || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return [];
      const exactLabel = Boolean(label && cell.hasAttribute('data-ok-exact-label'));
      const alt = image.alt?.trim() || state.config.productTitle;
      return [{src, msrc: image.currentSrc || image.src, w: width, h: height, title: alt, alt, okCell: cell, okMediaId: cell.dataset.okMediaId, okIsFacts: exactLabel, okLabelTitle: exactLabel ? label.title : ''}];
    });
  }

  function showImage(state, trigger, cell) {
    if (!mobile.matches || !cell || cell.dataset.okMediaType !== 'image') return false;
    const selected = state.section.querySelector('[data-product-select]');
    if (selected) state.variantId = selected.value;
    updateLabel(state);
    if (cell.hasAttribute('data-ok-exact-label')) return showFacts(state, trigger);
    state.error?.remove(); state.error = null;
    const items = imageItems(state);
    const index = items.findIndex(item => item.okCell === cell);
    if (index >= 0 && openImageViewer(state, trigger, items, index)) return true;
    const originalSource = index >= 0 ? items[index].src : cell.querySelector('img[data-photoswipe-src]')?.getAttribute('data-photoswipe-src');
    const message = document.createElement('p');
    message.setAttribute('role', 'status');
    message.className = 'ok-facts-unavailable';
    message.append(document.createTextNode(`${state.config.strings.imageUnavailable || state.config.strings.original} `));
    if (originalSource) {
      const original = document.createElement('a');
      original.href = originalSource; original.target = '_blank'; original.rel = 'noopener';
      original.textContent = state.config.strings.original;
      message.append(original);
    }
    state.container.append(message); state.error = message;
    return false;
  }

  function updateBottlePreviews(state) {
    const bottles = state.config.verifiedBottles || {};
    state.section.querySelectorAll('[data-ok-media-id]').forEach(slide => {
      const bottle = bottles[slide.dataset.okMediaId];
      if (!bottle) return;
      const img = slide.querySelector('img[data-photoswipe-src]');
      if (!img) return;
      if (!mobile.matches) {restoreImage(img); return;}
      if (!originalImages.has(img)) originalImages.set(img, Object.fromEntries(imageAttributes.map(name => [name, img.getAttribute(name)])));
      img.src = bottle.preview;
      img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.removeAttribute('data-widths');
      img.setAttribute('data-src', bottle.preview);
      img.setAttribute('data-aspectratio', String(bottle.width / bottle.height));
      img.setAttribute('width', String(bottle.width)); img.setAttribute('height', String(bottle.height));
      img.alt = bottle.alt;
      img.classList.remove('lazyload', 'lazyloading'); img.classList.add('lazyloaded');
      slide.setAttribute('data-ok-bottle-preview', 'true');
    });
  }

  function restoreImage(img) {
    const original = originalImages.get(img);
    if (!original) return;
    imageAttributes.forEach(name => original[name] === null ? img.removeAttribute(name) : img.setAttribute(name, original[name]));
    img.closest('[data-ok-media-id]')?.removeAttribute('data-ok-exact-label');
    img.closest('[data-ok-media-id]')?.removeAttribute('data-ok-bottle-preview');
    if (window.lazySizes && img.classList.contains('lazyload')) window.lazySizes.loader.unveil(img);
  }

  function updateLabel(state) {
    const label = labelFor(state.config, state.variantId);
    const link = state.container.querySelector('[data-ok-facts-link]');
    const fallback = state.container.querySelector('[data-ok-facts-fallback]');
    if (fallback) fallback.hidden = Boolean(label);
    if (link) {
      link.hidden = !label;
      if (label) {link.href = label.src; link.setAttribute('aria-label', `${state.config.strings.facts}: ${label.title}`);}
    }
    const mappedMediaIds = new Set(Object.values(state.config.verifiedVariants).flatMap(item => item.mediaIds || [item.mediaId]));
    state.section.querySelectorAll('[data-ok-media-id]').forEach(slide => {
      if (!mappedMediaIds.has(slide.dataset.okMediaId)) return;
      const img = slide.querySelector('img[data-photoswipe-src]');
      if (!img) return;
      if (!mobile.matches || !label || !(label.mediaIds || [label.mediaId]).includes(slide.dataset.okMediaId)) {restoreImage(img); return;}
      if (!originalImages.has(img)) originalImages.set(img, Object.fromEntries(imageAttributes.map(name => [name, img.getAttribute(name)])));
      img.src = label.preview;
      img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.removeAttribute('data-widths');
      img.setAttribute('data-src', label.preview);
      img.setAttribute('data-aspectratio', String(label.width / label.height));
      img.setAttribute('data-photoswipe-src', label.src);
      img.setAttribute('data-photoswipe-width', String(label.width));
      img.setAttribute('data-photoswipe-height', String(label.height));
      img.setAttribute('width', '800'); img.setAttribute('height', '800');
      img.alt = `${state.config.strings.facts}: ${state.config.productTitle}, ${label.title}`;
      img.classList.remove('lazyload', 'lazyloading'); img.classList.add('lazyloaded');
      slide.setAttribute('data-ok-exact-label', 'true');
    });
    updateBottlePreviews(state);
  }

  function enhance(state) {
    const slider = state.section.querySelector('[data-product-photos]');
    const photos = state.section.querySelector('[data-product-images]');
    if (!slider || !photos) return;
    const flkty = window.Flickity?.data(slider);
    if (state.flickity !== flkty) {
      if (state.flickity) {state.flickity.off('select', state.onSelect); state.flickity.off('staticClick', state.onStaticClick);}
      state.flickity = flkty || null;
      if (flkty) {
        state.originalWrapAround = flkty.options.wrapAround;
        if (mobile.matches) flkty.options.wrapAround = true;
        flkty.on('select', state.onSelect); flkty.on('staticClick', state.onStaticClick);
        flkty.resize();
      }
    }
    if (!state.controls) {
      const controls = document.createElement('div'); controls.className = 'ok-media-controls';
      state.counter = document.createElement('span'); state.counter.className = 'ok-media-controls__counter';
      state.counter.setAttribute('aria-live', 'polite'); state.counter.setAttribute('aria-atomic', 'true');
      state.previous = button(state.config.strings.previous, '‹', 'ok-media-controls__previous');
      state.next = button(state.config.strings.next, '›', 'ok-media-controls__next');
      state.zoom = button(state.config.strings.enlarge, '', 'ok-media-controls__zoom');
      state.zoom.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>';
      state.previous.addEventListener('click', () => state.flickity?.previous(true, reduced.matches));
      state.next.addEventListener('click', () => state.flickity?.next(true, reduced.matches));
      state.zoom.addEventListener('click', () => {
        const slide = state.flickity?.selectedElement || slider.querySelector('.starting-slide') || slider.querySelector('.product-main-slide');
        showImage(state, state.zoom, slide);
      });
      controls.append(state.counter, state.previous, state.next, state.zoom);
      photos.append(controls); state.controls = controls;
    }
    photos.classList.add('ok-media-gallery');
    state.onSelect(); updateLabel(state);
  }

  function init(container) {
    if (instances.has(container)) return;
    const section = container.closest('.product-section');
    if (!section || section.dataset.modal === 'true') return;
    let config;
    try {config = JSON.parse(container.querySelector('[data-ok-media-config]').textContent);} catch (_) {return;}
    const state = {container, section, config, variantId: container.dataset.okVariantId, controls: null, flickity: null};
    state.onSelect = () => {
      if (!state.controls) return;
      const slides = state.flickity ? state.flickity.getCellElements() : Array.from(section.querySelectorAll('.product-main-slide'));
      const selected = state.flickity?.selectedElement || section.querySelector('.starting-slide') || slides[0];
      const index = Math.max(0, slides.indexOf(selected));
      const total = slides.length;
      const counterText = `${index + 1} / ${total}`;
      if (state.counter.textContent !== counterText) state.counter.textContent = counterText;
      state.counter.setAttribute('aria-label', config.strings.counter.replace('[current]', String(index + 1)).replace('[total]', String(total)));
      state.counter.hidden = total <= 1; state.previous.hidden = total <= 1; state.next.hidden = total <= 1;
      state.previous.disabled = total < 2 || !state.flickity; state.next.disabled = total < 2 || !state.flickity;
      state.zoom.hidden = !selected?.querySelector('.js-photoswipe__zoom');
      if (mobile.matches) slides.forEach(slide => {slide.inert = slide !== selected;});
      else slides.forEach(slide => {slide.inert = false;});
    };
    state.onStaticClick = (event, pointer, cell) => {
      if (!mobile.matches || !cell || event.target.closest('button,a,video,iframe,model-viewer')) return;
      showImage(state, state.zoom, cell);
    };
    state.onFactsClick = event => {
      if (!mobile.matches) return;
      event.preventDefault();
      showFacts(state, event.currentTarget);
    };
    const factsLink = container.querySelector('[data-ok-facts-link]');
    factsLink?.addEventListener('click', state.onFactsClick);
    state.onZoomClick = event => {
      const trigger = event.target.closest('.js-photoswipe__zoom');
      const singleImage = state.flickity ? null : event.target.closest('img[data-photoswipe-src]');
      const cell = (trigger || singleImage)?.closest('[data-ok-media-id]');
      if (!mobile.matches || cell?.dataset.okMediaType !== 'image') return;
      event.preventDefault(); event.stopImmediatePropagation();
      showImage(state, state.zoom || trigger || singleImage, cell);
    };
    section.addEventListener('click', state.onZoomClick, true);
    state.onVariantChange = event => {
      const variant = event.detail?.variant;
      if (String(state.variantId) !== String(variant?.id || '') && activeViewer?.section === section) activeViewer.close(false);
      state.variantId = variant?.id || '';
      updateLabel(state);
    };
    section.addEventListener('variantChange', state.onVariantChange);
    const observer = new MutationObserver(() => {if (mobile.matches) enhance(state);});
    const observeNativeMedia = () => {const slider = section.querySelector('[data-product-photos]'); if (slider && mobile.matches) observer.observe(slider, {childList: true, subtree: true});};
    observeNativeMedia();
    state.onMediaChange = () => {
      observer.disconnect(); observeNativeMedia();
      if (mobile.matches) enhance(state);
      if (!mobile.matches && activeViewer) activeViewer.close(false);
      if (state.flickity) state.flickity.options.wrapAround = mobile.matches ? true : state.originalWrapAround;
      updateLabel(state); state.onSelect(); state.flickity?.resize();
    };
    mobile.addEventListener('change', state.onMediaChange);
    state.refresh = () => {
      const selected = section.querySelector('[data-product-select]');
      if (selected) state.variantId = selected.value;
      state.onMediaChange();
    };
    state.cleanup = () => {
      observer.disconnect(); mobile.removeEventListener('change', state.onMediaChange);
      section.removeEventListener('variantChange', state.onVariantChange);
      section.removeEventListener('click', state.onZoomClick, true);
      factsLink?.removeEventListener('click', state.onFactsClick);
      window.removeEventListener('load', state.refresh);
      if (state.flickity) {state.flickity.off('select', state.onSelect); state.flickity.off('staticClick', state.onStaticClick);}
      if (activeViewer?.section === section) activeViewer.close(false);
      state.controls?.remove(); state.error?.remove();
      instances.delete(container);
    };
    instances.set(container, state);
    enhance(state);
    window.addEventListener('load', state.refresh, {once: true});
  }

  const boot = root => root.querySelectorAll('[data-ok-facts]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once: true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ok-facts]').forEach(container => instances.get(container)?.cleanup()));
  window.addEventListener('pagehide', () => activeViewer?.close(false));
  window.addEventListener('pageshow', () => {
    boot(document);
    document.querySelectorAll('[data-ok-facts]').forEach(container => instances.get(container)?.refresh());
  });
})();



